<template>
  <v-navigation-drawer v-model="$root.drawer" app clipped temporary>
    <v-app-bar flat color="#303030">
      <v-row align="center" justify="center">
        <p class="pt-6 primary--text">
          Navigation
        </p>
        <v-spacer />
        <v-icon>mdi-chevron-left</v-icon>
      </v-row>
    </v-app-bar>
    <v-list dense shaped>
      <v-list-item-group
        v-model="active"
        mandatory
        active-class="primary white--text"
      >
        <inertia-link :href="route('dashboard')">
          <v-list-item value="dashboard" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-cart-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Vertriebs-Ansicht</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-list-group :v-model="showWarehouse" prepend-icon="mdi-warehouse">
          <template #activator>
            <v-list-item-title>Warenlager</v-list-item-title>
          </template>
          <inertia-link :href="route('warehouse.article.index')">
            <v-list-item
              class="ml-3"
              :value="route('warehouse.article.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>
                  Artikel
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-format-list-checkbox</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>
          <inertia-link :href="route('warehouse.index')">
            <v-list-item
              class="ml-3"
              :value="route('warehouse.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>
                  Lager
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-warehouse</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>
        </v-list-group>

        <v-list-group :v-model="showShop" prepend-icon="mdi-store">
          <template #activator>
            <v-list-item-title>Geschäft</v-list-item-title>
          </template>
          <inertia-link :href="route('item.index')">
            <v-list-item
              class="ml-3"
              :value="route('item.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Verkaufsartikel</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-cash-register</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>
          <inertia-link :href="route('product.index')">
            <v-list-item
              class="ml-3"
              :value="route('product.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Produkt</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-cart</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>

          <inertia-link :href="route('bundle.index')">
            <v-list-item
              class="ml-3"
              :value="route('bundle.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Bundle</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-basket</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>

          <inertia-link :href="route('bundle.group.index')">
            <v-list-item
              class="ml-3"
              :value="route('bundle.group.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Bundle Gruppen</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-basket</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>
        </v-list-group>

        <!-- <v-list-group
          :v-model="showStatistics"
          prepend-icon="mdi-calculator-variant"
        >
          <template #activator>
            <v-list-item-title>Statistiken</v-list-item-title>
          </template>
          <inertia-link :href="route('statistic.contract.show', 'contracts')">
            <v-list-item
              class="ml-3"
              :value="route('statistic.contract.show', 'contracts')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Vertragsstatistik</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-file-star</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>
        </v-list-group> -->

        <v-list-group :v-model="showStatistics" prepend-icon="mdi-file-table">
          <template #activator>
            <v-list-item-title>CSV-Dateien</v-list-item-title>
          </template>

          <v-list-item
            class="ml-3"
            :value="route('contracts.partslist')"
            :href="route('contracts.partslist')"
            @click="$root.drawer = false"
          >
            <v-list-item-content>
              <v-list-item-title>Einkaufsartikel-Verträge</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="ml-3"
            :value="route('warehouse.csv')"
            :href="route('warehouse.csv')"
            @click="$root.drawer = false"
          >
            <v-list-item-content>
              <v-list-item-title>Einkaufsartikel-Lager</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group :v-model="showSettings" prepend-icon="mdi-cog">
          <template #activator>
            <v-list-item-title>Einstellungen</v-list-item-title>
          </template>
          <inertia-link :href="route('tax.index')">
            <v-list-item
              class="ml-3"
              :value="route('tax.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Steuern</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-alpha-t</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>

          <inertia-link :href="route('term.index')">
            <v-list-item
              class="ml-3"
              :value="route('term.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title>Bedingungen</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-alpha-t</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>

          <inertia-link :href="route('attribute.index')">
            <v-list-item
              class="ml-3"
              :value="route('attribute.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title> Attribute </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-alpha-a</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>

          <inertia-link :href="route('control_logic.index')">
            <v-list-item
              class="ml-3"
              :value="route('control_logic.index')"
              @click="$root.drawer = false"
            >
              <v-list-item-content>
                <v-list-item-title> Kontroll Logik </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-lan</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </inertia-link>
        </v-list-group>

        <inertia-link :href="route('admin.user.index')">
          <v-list-item
            :value="route('admin.user.index')"
            @click="$root.drawer = false"
          >
            <v-list-item-content>
              <v-list-item-title>Benutzer Verwaltung</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-account-cog</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </inertia-link>

        <inertia-link :href="route('admin.team.index')">
          <v-list-item
            :value="route('admin.team.index')"
            @click="$root.drawer = false"
          >
            <v-list-item-content>
              <v-list-item-title>Team-Verwaltung</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-account-cog</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </inertia-link>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
   name: 'AdminSidebar',
   data () {
      return {
         active: this.route().current().split('.')[0],
         showShop: false,
         showSettings: false,
         showCustomer: false,
         showStatistics: false,
         showIncoming: false,
         showWarehouse: false,
      }
   },
   methods: {
      navigateTo (route) {
         this.$inertia.visit(this.route(route))
         this.$root.drawer = false
      },
   },
}
</script>
